export const brand = 'chill'

export const turbo = false

export const date = 'Mon Jun 02 2025 10:26:20 GMT+0000 (Coordinated Universal Time)'

export const debug = false

export const version = 'v-36.0.4'

export const hash = '5de1c23'

export const token = 'the great world tree'

export const url = 'Error! No beUrl was specified'

export const netPosition = true

export const timeElapsed = true

export const social = false

export const lang = 'en'
